__turbopack_context__.v({
  "card-field": "CardItem-module-scss-module__sMvcvW__card-field",
  "card-field-btn": "CardItem-module-scss-module__sMvcvW__card-field-btn",
  "drag-to-reorder-handle": "CardItem-module-scss-module__sMvcvW__drag-to-reorder-handle",
  "edit-icon": "CardItem-module-scss-module__sMvcvW__edit-icon",
  "lock-message-fade-in": "CardItem-module-scss-module__sMvcvW__lock-message-fade-in",
});
